import * as React from "react";
import { i18n, i18nCustom, i18nGetMeta } from "./i18n";
export class Message extends React.Component<any> {
  render() {
    const { lang, langKey, getArg } = this.props;
    let meta = i18nGetMeta(lang, langKey);

    if (!meta) {
      return "[" + langKey + "]";
    }

    const params = {};
    meta.params.forEach((param) => {
      params[param] = getArg(param);
    });
    console.log("META", meta, params);
    const parts = meta.text.split(/{(\d+)}/g);
    return (
      <span>
        {parts.map((part) => {
          if (!isNaN(part)) {
            return params[part];
          } else {
            return part;
          }
        })}
      </span>
    );
  }
}

/**
 * Vrátí brand title včetně vyřešení implicitního textu, pokud není text vůbec definován.
 * @return {*|string|string}
 */
export function brandTitle(lang) {
    return i18nCustom(lang, "PORTAL_BRAND_TITLE", false) || "Portál občana";
}
